import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _d0b51f28 = () => interopDefault(import('../pages/account.vue' /* webpackChunkName: "pages/account" */))
const _d511a734 = () => interopDefault(import('../pages/account/general-info.vue' /* webpackChunkName: "pages/account/general-info" */))
const _3558b818 = () => interopDefault(import('../pages/account/orders.vue' /* webpackChunkName: "pages/account/orders" */))
const _5e77520a = () => interopDefault(import('../pages/account/referral-info.vue' /* webpackChunkName: "pages/account/referral-info" */))
const _995b75e6 = () => interopDefault(import('../pages/account/user-info.vue' /* webpackChunkName: "pages/account/user-info" */))
const _75ca1f97 = () => interopDefault(import('../pages/checkout.vue' /* webpackChunkName: "pages/checkout" */))
const _5ff84375 = () => interopDefault(import('../pages/checkout/index.js' /* webpackChunkName: "pages/checkout/index" */))
const _15d7f1af = () => interopDefault(import('../pages/checkout/order-summary.vue' /* webpackChunkName: "pages/checkout/order-summary" */))
const _a12467e4 = () => interopDefault(import('../pages/checkout/payment.vue' /* webpackChunkName: "pages/checkout/payment" */))
const _a0c62146 = () => interopDefault(import('../pages/checkout/personal-details.vue' /* webpackChunkName: "pages/checkout/personal-details" */))
const _458bb9ac = () => interopDefault(import('../pages/event-list-page.vue' /* webpackChunkName: "pages/event-list-page" */))
const _1c5c0055 = () => interopDefault(import('../pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _784f13f6 = () => interopDefault(import('../pages/impressum.vue' /* webpackChunkName: "pages/impressum" */))
const _02c00deb = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _3c8aa6e5 = () => interopDefault(import('../pages/magazine.vue' /* webpackChunkName: "pages/magazine" */))
const _f3b26f68 = () => interopDefault(import('../pages/magazine/article.vue' /* webpackChunkName: "pages/magazine/article" */))
const _723a8498 = () => interopDefault(import('../pages/magazine/category.vue' /* webpackChunkName: "pages/magazine/category" */))
const _4ae15218 = () => interopDefault(import('../pages/magazine/magazine-wrapper.vue' /* webpackChunkName: "pages/magazine/magazine-wrapper" */))
const _bae233fa = () => interopDefault(import('../pages/order-success.vue' /* webpackChunkName: "pages/order-success" */))
const _562202ca = () => interopDefault(import('../pages/partner/index.vue' /* webpackChunkName: "pages/partner/index" */))
const _4ab96bae = () => interopDefault(import('../pages/password-reset.vue' /* webpackChunkName: "pages/password-reset" */))
const _fb38b292 = () => interopDefault(import('../pages/ping-default.vue' /* webpackChunkName: "pages/ping-default" */))
const _d8fe51c6 = () => interopDefault(import('../pages/ping-optimized.vue' /* webpackChunkName: "pages/ping-optimized" */))
const _2305a243 = () => interopDefault(import('../pages/ping.vue' /* webpackChunkName: "pages/ping" */))
const _c510a0a0 = () => interopDefault(import('../pages/root-domain/home.vue' /* webpackChunkName: "" */))
const _5cf19139 = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _54cde218 = () => interopDefault(import('../pages/sitemap.vue' /* webpackChunkName: "pages/sitemap" */))
const _427ac8c1 = () => interopDefault(import('../pages/stripe-3d-auth-complete.vue' /* webpackChunkName: "pages/stripe-3d-auth-complete" */))
const _87e7fb08 = () => interopDefault(import('../pages/sub-domain/home.vue' /* webpackChunkName: "" */))
const _716f1742 = () => interopDefault(import('../pages/teamevent/index.vue' /* webpackChunkName: "pages/teamevent/index" */))
const _56bc6f45 = () => interopDefault(import('../pages/terms-and-conditions.vue' /* webpackChunkName: "pages/terms-and-conditions" */))
const _155238e3 = () => interopDefault(import('../pages/terms-supplier.vue' /* webpackChunkName: "pages/terms-supplier" */))
const _82305be2 = () => interopDefault(import('../pages/auth/social-login.vue' /* webpackChunkName: "pages/auth/social-login" */))
const _b1f895a0 = () => interopDefault(import('../pages/city-category/city-category.vue' /* webpackChunkName: "pages/city-category/city-category" */))
const _39214825 = () => interopDefault(import('../pages/embedded/booking.vue' /* webpackChunkName: "pages/embedded/booking" */))
const _3618eed4 = () => interopDefault(import('../pages/embedded/button.vue' /* webpackChunkName: "pages/embedded/button" */))
const _48b2cf44 = () => interopDefault(import('../pages/login/forgot-password.vue' /* webpackChunkName: "pages/login/forgot-password" */))
const _6830f425 = () => interopDefault(import('../pages/partner/booking-solution.vue' /* webpackChunkName: "pages/partner/booking-solution" */))
const _bd277084 = () => interopDefault(import('../pages/partner/pricing.vue' /* webpackChunkName: "pages/partner/pricing" */))
const _58506a11 = () => interopDefault(import('../pages/root-domain/giftcard.vue' /* webpackChunkName: "pages/root-domain/giftcard" */))
const _22a8a72e = () => interopDefault(import('../pages/special-giftcard/special-giftcard.vue' /* webpackChunkName: "pages/special-giftcard/special-giftcard" */))
const _c8b31246 = () => interopDefault(import('../pages/sub-domain/giftcard.vue' /* webpackChunkName: "pages/sub-domain/giftcard" */))
const _bf44922c = () => interopDefault(import('../pages/t/general-event-list-page.vue' /* webpackChunkName: "pages/t/general-event-list-page" */))
const _24017c8a = () => interopDefault(import('../pages/c/_categorySlug.vue' /* webpackChunkName: "pages/c/_categorySlug" */))
const _90cbe692 = () => interopDefault(import('../pages/city/_city.vue' /* webpackChunkName: "pages/city/_city" */))
const _26ce8556 = () => interopDefault(import('../pages/e/_event.vue' /* webpackChunkName: "pages/e/_event" */))
const _50d89e4c = () => interopDefault(import('../pages/e/_event/index.ts' /* webpackChunkName: "pages/e/_event/index" */))
const _7ddbd71d = () => interopDefault(import('../pages/e/_event/BasicDetails.vue' /* webpackChunkName: "pages/e/_event/BasicDetails" */))
const _421ebd82 = () => interopDefault(import('../pages/e/_event/EventBreadcrumbs.vue' /* webpackChunkName: "pages/e/_event/EventBreadcrumbs" */))
const _65da9d58 = () => interopDefault(import('../pages/e/_event/EventIconList.vue' /* webpackChunkName: "pages/e/_event/EventIconList" */))
const _89284d78 = () => interopDefault(import('../pages/e/_event/EventIconList/EventIconListTable.vue' /* webpackChunkName: "pages/e/_event/EventIconList/EventIconListTable" */))
const _0b2b2c0e = () => interopDefault(import('../pages/e/_event/Gallery.vue' /* webpackChunkName: "pages/e/_event/Gallery" */))
const _f1ed447a = () => interopDefault(import('../pages/e/_event/LocationAndMap.vue' /* webpackChunkName: "pages/e/_event/LocationAndMap" */))
const _0daae7e4 = () => interopDefault(import('../pages/e/_event/PrivateEventInfo.vue' /* webpackChunkName: "pages/e/_event/PrivateEventInfo" */))
const _12981964 = () => interopDefault(import('../pages/e/_event/ReviewShowcase.vue' /* webpackChunkName: "pages/e/_event/ReviewShowcase" */))
const _4ea4cdaa = () => interopDefault(import('../pages/e/_event/composables/useEventBreadcrumbs.ts' /* webpackChunkName: "pages/e/_event/composables/useEventBreadcrumbs" */))
const _8d5aff08 = () => interopDefault(import('../pages/e/_event/composables/useKftBuyBox.ts' /* webpackChunkName: "pages/e/_event/composables/useKftBuyBox" */))
const _472b5888 = () => interopDefault(import('../pages/p/_permalink.vue' /* webpackChunkName: "pages/p/_permalink" */))
const _599ca35a = () => interopDefault(import('../pages/preview/_previewPermalink.vue' /* webpackChunkName: "pages/preview/_previewPermalink" */))
const _60712eb1 = () => interopDefault(import('../pages/review/_event.vue' /* webpackChunkName: "pages/review/_event" */))
const _afd5bc52 = () => interopDefault(import('../pages/teamevent/_city.vue' /* webpackChunkName: "pages/teamevent/_city" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/de-de/account/",
    component: _d0b51f28,
    pathToRegexpOptions: {"strict":true},
    name: "account___de-de",
    children: [{
      path: "general-info/",
      component: _d511a734,
      pathToRegexpOptions: {"strict":true},
      name: "account-general-info___de-de"
    }, {
      path: "orders/",
      component: _3558b818,
      pathToRegexpOptions: {"strict":true},
      name: "account-orders___de-de"
    }, {
      path: "referral-info/",
      component: _5e77520a,
      pathToRegexpOptions: {"strict":true},
      name: "account-referral-info___de-de"
    }, {
      path: "user-info/",
      component: _995b75e6,
      pathToRegexpOptions: {"strict":true},
      name: "account-user-info___de-de"
    }]
  }, {
    path: "/de-de/checkout/",
    component: _75ca1f97,
    pathToRegexpOptions: {"strict":true},
    children: [{
      path: "",
      component: _5ff84375,
      pathToRegexpOptions: {"strict":true},
      name: "checkout___de-de"
    }, {
      path: "order-summary/",
      component: _15d7f1af,
      pathToRegexpOptions: {"strict":true},
      name: "checkout-order-summary___de-de"
    }, {
      path: "payment/",
      component: _a12467e4,
      pathToRegexpOptions: {"strict":true},
      name: "checkout-payment___de-de"
    }, {
      path: "personal-details/",
      component: _a0c62146,
      pathToRegexpOptions: {"strict":true},
      name: "checkout-personal-details___de-de"
    }]
  }, {
    path: "/de-de/event-list-page/",
    component: _458bb9ac,
    pathToRegexpOptions: {"strict":true},
    name: "event-list-page___de-de"
  }, {
    path: "/de-de/faq/",
    component: _1c5c0055,
    pathToRegexpOptions: {"strict":true},
    name: "faq___de-de"
  }, {
    path: "/de-de/impressum/",
    component: _784f13f6,
    pathToRegexpOptions: {"strict":true},
    name: "impressum___de-de"
  }, {
    path: "/de-de/login/",
    component: _02c00deb,
    pathToRegexpOptions: {"strict":true},
    name: "login___de-de"
  }, {
    path: "/de-de/magazine/",
    component: _3c8aa6e5,
    pathToRegexpOptions: {"strict":true},
    name: "magazine___de-de",
    children: [{
      path: "article/",
      component: _f3b26f68,
      pathToRegexpOptions: {"strict":true},
      name: "magazine-article___de-de"
    }, {
      path: "category/",
      component: _723a8498,
      pathToRegexpOptions: {"strict":true},
      name: "magazine-category___de-de"
    }, {
      path: "magazine-wrapper/",
      component: _4ae15218,
      pathToRegexpOptions: {"strict":true},
      name: "magazine-magazine-wrapper___de-de"
    }]
  }, {
    path: "/de-de/order-success/",
    component: _bae233fa,
    pathToRegexpOptions: {"strict":true},
    name: "order-success___de-de"
  }, {
    path: "/de-de/partner/",
    component: _562202ca,
    pathToRegexpOptions: {"strict":true},
    name: "partner___de-de"
  }, {
    path: "/de-de/password-reset/",
    component: _4ab96bae,
    pathToRegexpOptions: {"strict":true},
    name: "password-reset___de-de"
  }, {
    path: "/de-de/ping-default/",
    component: _fb38b292,
    pathToRegexpOptions: {"strict":true},
    name: "ping-default___de-de"
  }, {
    path: "/de-de/ping-optimized/",
    component: _d8fe51c6,
    pathToRegexpOptions: {"strict":true},
    name: "ping-optimized___de-de"
  }, {
    path: "/de-de/ping/",
    component: _2305a243,
    pathToRegexpOptions: {"strict":true},
    name: "ping___de-de"
  }, {
    path: "/de-de/root-domain/",
    component: _c510a0a0,
    props: true,
    name: "home___de-de"
  }, {
    path: "/de-de/search/",
    component: _5cf19139,
    pathToRegexpOptions: {"strict":true},
    name: "search___de-de"
  }, {
    path: "/de-de/sitemap/",
    component: _54cde218,
    pathToRegexpOptions: {"strict":true},
    name: "sitemap___de-de"
  }, {
    path: "/de-de/stripe-3d-auth-complete/",
    component: _427ac8c1,
    pathToRegexpOptions: {"strict":true},
    name: "stripe-3d-auth-complete___de-de"
  }, {
    path: "/de-de/sub-domain/",
    component: _87e7fb08,
    props: true,
    name: "supplier-home___de-de"
  }, {
    path: "/de-de/teamevent/",
    component: _716f1742,
    pathToRegexpOptions: {"strict":true},
    name: "teamevent___de-de"
  }, {
    path: "/de-de/terms-and-conditions/",
    component: _56bc6f45,
    pathToRegexpOptions: {"strict":true},
    name: "terms-and-conditions___de-de"
  }, {
    path: "/de-de/terms-supplier/",
    component: _155238e3,
    pathToRegexpOptions: {"strict":true},
    name: "terms-supplier___de-de"
  }, {
    path: "/en-us/account/",
    component: _d0b51f28,
    pathToRegexpOptions: {"strict":true},
    name: "account___en-us",
    children: [{
      path: "general-info/",
      component: _d511a734,
      pathToRegexpOptions: {"strict":true},
      name: "account-general-info___en-us"
    }, {
      path: "orders/",
      component: _3558b818,
      pathToRegexpOptions: {"strict":true},
      name: "account-orders___en-us"
    }, {
      path: "referral-info/",
      component: _5e77520a,
      pathToRegexpOptions: {"strict":true},
      name: "account-referral-info___en-us"
    }, {
      path: "user-info/",
      component: _995b75e6,
      pathToRegexpOptions: {"strict":true},
      name: "account-user-info___en-us"
    }]
  }, {
    path: "/en-us/checkout/",
    component: _75ca1f97,
    pathToRegexpOptions: {"strict":true},
    children: [{
      path: "",
      component: _5ff84375,
      pathToRegexpOptions: {"strict":true},
      name: "checkout___en-us"
    }, {
      path: "order-summary/",
      component: _15d7f1af,
      pathToRegexpOptions: {"strict":true},
      name: "checkout-order-summary___en-us"
    }, {
      path: "payment/",
      component: _a12467e4,
      pathToRegexpOptions: {"strict":true},
      name: "checkout-payment___en-us"
    }, {
      path: "personal-details/",
      component: _a0c62146,
      pathToRegexpOptions: {"strict":true},
      name: "checkout-personal-details___en-us"
    }]
  }, {
    path: "/en-us/event-list-page/",
    component: _458bb9ac,
    pathToRegexpOptions: {"strict":true},
    name: "event-list-page___en-us"
  }, {
    path: "/en-us/faq/",
    component: _1c5c0055,
    pathToRegexpOptions: {"strict":true},
    name: "faq___en-us"
  }, {
    path: "/en-us/impressum/",
    component: _784f13f6,
    pathToRegexpOptions: {"strict":true},
    name: "impressum___en-us"
  }, {
    path: "/en-us/login/",
    component: _02c00deb,
    pathToRegexpOptions: {"strict":true},
    name: "login___en-us"
  }, {
    path: "/en-us/magazine/",
    component: _3c8aa6e5,
    pathToRegexpOptions: {"strict":true},
    name: "magazine___en-us",
    children: [{
      path: "article/",
      component: _f3b26f68,
      pathToRegexpOptions: {"strict":true},
      name: "magazine-article___en-us"
    }, {
      path: "category/",
      component: _723a8498,
      pathToRegexpOptions: {"strict":true},
      name: "magazine-category___en-us"
    }, {
      path: "magazine-wrapper/",
      component: _4ae15218,
      pathToRegexpOptions: {"strict":true},
      name: "magazine-magazine-wrapper___en-us"
    }]
  }, {
    path: "/en-us/order-success/",
    component: _bae233fa,
    pathToRegexpOptions: {"strict":true},
    name: "order-success___en-us"
  }, {
    path: "/en-us/partner/",
    component: _562202ca,
    pathToRegexpOptions: {"strict":true},
    name: "partner___en-us"
  }, {
    path: "/en-us/password-reset/",
    component: _4ab96bae,
    pathToRegexpOptions: {"strict":true},
    name: "password-reset___en-us"
  }, {
    path: "/en-us/ping-default/",
    component: _fb38b292,
    pathToRegexpOptions: {"strict":true},
    name: "ping-default___en-us"
  }, {
    path: "/en-us/ping-optimized/",
    component: _d8fe51c6,
    pathToRegexpOptions: {"strict":true},
    name: "ping-optimized___en-us"
  }, {
    path: "/en-us/ping/",
    component: _2305a243,
    pathToRegexpOptions: {"strict":true},
    name: "ping___en-us"
  }, {
    path: "/en-us/root-domain/",
    component: _c510a0a0,
    props: true,
    name: "home___en-us"
  }, {
    path: "/en-us/search/",
    component: _5cf19139,
    pathToRegexpOptions: {"strict":true},
    name: "search___en-us"
  }, {
    path: "/en-us/sitemap/",
    component: _54cde218,
    pathToRegexpOptions: {"strict":true},
    name: "sitemap___en-us"
  }, {
    path: "/en-us/stripe-3d-auth-complete/",
    component: _427ac8c1,
    pathToRegexpOptions: {"strict":true},
    name: "stripe-3d-auth-complete___en-us"
  }, {
    path: "/en-us/sub-domain/",
    component: _87e7fb08,
    props: true,
    name: "supplier-home___en-us"
  }, {
    path: "/en-us/teamevent/",
    component: _716f1742,
    pathToRegexpOptions: {"strict":true},
    name: "teamevent___en-us"
  }, {
    path: "/en-us/terms-and-conditions/",
    component: _56bc6f45,
    pathToRegexpOptions: {"strict":true},
    name: "terms-and-conditions___en-us"
  }, {
    path: "/en-us/terms-supplier/",
    component: _155238e3,
    pathToRegexpOptions: {"strict":true},
    name: "terms-supplier___en-us"
  }, {
    path: "/de-de/auth/social-login/",
    component: _82305be2,
    pathToRegexpOptions: {"strict":true},
    name: "auth-social-login___de-de"
  }, {
    path: "/de-de/city-category/city-category/",
    component: _b1f895a0,
    pathToRegexpOptions: {"strict":true},
    name: "city-category-city-category___de-de"
  }, {
    path: "/de-de/embedded/booking/",
    component: _39214825,
    pathToRegexpOptions: {"strict":true},
    name: "embedded-booking___de-de"
  }, {
    path: "/de-de/embedded/button/",
    component: _3618eed4,
    pathToRegexpOptions: {"strict":true},
    name: "embedded-button___de-de"
  }, {
    path: "/de-de/login/forgot-password/",
    component: _48b2cf44,
    pathToRegexpOptions: {"strict":true},
    name: "login-forgot-password___de-de"
  }, {
    path: "/de-de/partner/booking-solution/",
    component: _6830f425,
    pathToRegexpOptions: {"strict":true},
    name: "partner-booking-solution___de-de"
  }, {
    path: "/de-de/partner/pricing/",
    component: _bd277084,
    pathToRegexpOptions: {"strict":true},
    name: "partner-pricing___de-de"
  }, {
    path: "/de-de/root-domain/giftcard/",
    component: _58506a11,
    pathToRegexpOptions: {"strict":true},
    name: "root-domain-giftcard___de-de"
  }, {
    path: "/de-de/root-domain/giftcard/",
    component: _58506a11,
    meta: {"contentGroup":"giftcard"},
    props: true,
    name: "gifcard-page___de-de"
  }, {
    path: "/de-de/root-domain/home/",
    component: _c510a0a0,
    pathToRegexpOptions: {"strict":true},
    name: "root-domain-home___de-de"
  }, {
    path: "/de-de/special-giftcard/special-giftcard/",
    component: _22a8a72e,
    pathToRegexpOptions: {"strict":true},
    name: "event___de-de"
  }, {
    path: "/de-de/sub-domain/giftcard/",
    component: _c8b31246,
    pathToRegexpOptions: {"strict":true},
    name: "sub-domain-giftcard___de-de"
  }, {
    path: "/de-de/sub-domain/giftcard/",
    component: _c8b31246,
    props: true,
    name: "supplier-giftcard-page___de-de"
  }, {
    path: "/de-de/sub-domain/home/",
    component: _87e7fb08,
    pathToRegexpOptions: {"strict":true},
    name: "sub-domain-home___de-de"
  }, {
    path: "/de-de/t/general-event-list-page/",
    component: _bf44922c,
    pathToRegexpOptions: {"strict":true},
    name: "t-general-event-list-page___de-de"
  }, {
    path: "/en-us/auth/social-login/",
    component: _82305be2,
    pathToRegexpOptions: {"strict":true},
    name: "auth-social-login___en-us"
  }, {
    path: "/en-us/city-category/city-category/",
    component: _b1f895a0,
    pathToRegexpOptions: {"strict":true},
    name: "city-category-city-category___en-us"
  }, {
    path: "/en-us/embedded/booking/",
    component: _39214825,
    pathToRegexpOptions: {"strict":true},
    name: "embedded-booking___en-us"
  }, {
    path: "/en-us/embedded/button/",
    component: _3618eed4,
    pathToRegexpOptions: {"strict":true},
    name: "embedded-button___en-us"
  }, {
    path: "/en-us/login/forgot-password/",
    component: _48b2cf44,
    pathToRegexpOptions: {"strict":true},
    name: "login-forgot-password___en-us"
  }, {
    path: "/en-us/partner/booking-solution/",
    component: _6830f425,
    pathToRegexpOptions: {"strict":true},
    name: "partner-booking-solution___en-us"
  }, {
    path: "/en-us/partner/pricing/",
    component: _bd277084,
    pathToRegexpOptions: {"strict":true},
    name: "partner-pricing___en-us"
  }, {
    path: "/en-us/root-domain/giftcard/",
    component: _58506a11,
    pathToRegexpOptions: {"strict":true},
    name: "root-domain-giftcard___en-us"
  }, {
    path: "/en-us/root-domain/giftcard/",
    component: _58506a11,
    meta: {"contentGroup":"giftcard"},
    props: true,
    name: "gifcard-page___en-us"
  }, {
    path: "/en-us/root-domain/home/",
    component: _c510a0a0,
    pathToRegexpOptions: {"strict":true},
    name: "root-domain-home___en-us"
  }, {
    path: "/en-us/special-giftcard/special-giftcard/",
    component: _22a8a72e,
    pathToRegexpOptions: {"strict":true},
    name: "event___en-us"
  }, {
    path: "/en-us/sub-domain/giftcard/",
    component: _c8b31246,
    pathToRegexpOptions: {"strict":true},
    name: "sub-domain-giftcard___en-us"
  }, {
    path: "/en-us/sub-domain/giftcard/",
    component: _c8b31246,
    props: true,
    name: "supplier-giftcard-page___en-us"
  }, {
    path: "/en-us/sub-domain/home/",
    component: _87e7fb08,
    pathToRegexpOptions: {"strict":true},
    name: "sub-domain-home___en-us"
  }, {
    path: "/en-us/t/general-event-list-page/",
    component: _bf44922c,
    pathToRegexpOptions: {"strict":true},
    name: "t-general-event-list-page___en-us"
  }, {
    path: "/de-de/auth/facebook/callback/",
    component: _82305be2,
    meta: {"socialLoginType":"facebook"},
    name: "social-login-facebook___de-de"
  }, {
    path: "/de-de/auth/google/callback/",
    component: _82305be2,
    meta: {"socialLoginType":"google"},
    name: "social-login-google___de-de"
  }, {
    path: "/en-us/auth/facebook/callback/",
    component: _82305be2,
    meta: {"socialLoginType":"facebook"},
    name: "social-login-facebook___en-us"
  }, {
    path: "/en-us/auth/google/callback/",
    component: _82305be2,
    meta: {"socialLoginType":"google"},
    name: "social-login-google___en-us"
  }, {
    path: "/de-de/c/:categorySlug?/",
    component: _24017c8a,
    pathToRegexpOptions: {"strict":true},
    name: "c-categorySlug___de-de"
  }, {
    path: "/de-de/city/:city?/",
    component: _90cbe692,
    pathToRegexpOptions: {"strict":true},
    name: "city-city___de-de"
  }, {
    path: "/de-de/e/:event?/",
    component: _26ce8556,
    pathToRegexpOptions: {"strict":true},
    name: "event___de-de",
    children: [{
      path: "",
      component: _50d89e4c,
      pathToRegexpOptions: {"strict":true},
      name: "e-event___de-de"
    }, {
      path: "BasicDetails/",
      component: _7ddbd71d,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-BasicDetails___de-de"
    }, {
      path: "EventBreadcrumbs/",
      component: _421ebd82,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-EventBreadcrumbs___de-de"
    }, {
      path: "EventIconList/",
      component: _65da9d58,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-EventIconList___de-de",
      children: [{
        path: "EventIconListTable/",
        component: _89284d78,
        pathToRegexpOptions: {"strict":true},
        name: "e-event-EventIconList-EventIconListTable___de-de"
      }]
    }, {
      path: "Gallery/",
      component: _0b2b2c0e,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-Gallery___de-de"
    }, {
      path: "LocationAndMap/",
      component: _f1ed447a,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-LocationAndMap___de-de"
    }, {
      path: "PrivateEventInfo/",
      component: _0daae7e4,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-PrivateEventInfo___de-de"
    }, {
      path: "ReviewShowcase/",
      component: _12981964,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-ReviewShowcase___de-de"
    }, {
      path: "composables/useEventBreadcrumbs/",
      component: _4ea4cdaa,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-composables-useEventBreadcrumbs___de-de"
    }, {
      path: "composables/useKftBuyBox/",
      component: _8d5aff08,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-composables-useKftBuyBox___de-de"
    }]
  }, {
    path: "/de-de/e/:event/",
    component: _26ce8556,
    meta: {"contentGroup":"event"},
    props: true,
    pathToRegexpOptions: {"strict":true},
    name: "event-page___de-de"
  }, {
    path: "/de-de/giftcard/:event/",
    component: _22a8a72e,
    meta: {"contentGroup":"giftcard"},
    props: true,
    pathToRegexpOptions: {"strict":true},
    name: "special-giftcards___de-de"
  }, {
    path: "/de-de/giftcard/:event/",
    component: _22a8a72e,
    meta: {"contentGroup":"giftcard"},
    props: true,
    pathToRegexpOptions: {"strict":true},
    name: "special-giftcards___de-de"
  }, {
    path: "/de-de/magazine/:slug/",
    component: _4ae15218,
    meta: {"contentGroup":"magazine"},
    props: true,
    name: "magazine-pages___de-de"
  }, {
    path: "/de-de/p/:permalink?/",
    component: _472b5888,
    pathToRegexpOptions: {"strict":true},
    name: "p-permalink___de-de"
  }, {
    path: "/de-de/p/:permalink/",
    component: _472b5888,
    meta: {"contentGroup":"partner"},
    props: true,
    name: "supplier-profile___de-de"
  }, {
    path: "/de-de/p/:permalink/",
    component: _472b5888,
    meta: {"contentGroup":"partner"},
    props: true,
    name: "supplier-profile___de-de"
  }, {
    path: "/de-de/preview/:previewPermalink?/",
    component: _599ca35a,
    pathToRegexpOptions: {"strict":true},
    name: "preview-previewPermalink___de-de"
  }, {
    path: "/de-de/review/:event?/",
    component: _60712eb1,
    pathToRegexpOptions: {"strict":true},
    name: "review-event___de-de"
  }, {
    path: "/de-de/t/:slug/",
    component: _bf44922c,
    meta: {"contentGroup":"tag"},
    props: true,
    name: "general-event-list-page___de-de"
  }, {
    path: "/de-de/t/:slug/",
    component: _bf44922c,
    meta: {"contentGroup":"tag"},
    props: true,
    name: "general-event-list-page___de-de"
  }, {
    path: "/de-de/teamevent/:city/",
    component: _afd5bc52,
    pathToRegexpOptions: {"strict":true},
    name: "teamevent-city___de-de"
  }, {
    path: "/de-de/teamevent/:city/",
    component: _afd5bc52,
    meta: {"contentGroup":"team event"},
    props: true,
    name: "team-event-page___de-de"
  }, {
    path: "/de-de/teamevent/:city/",
    component: _afd5bc52,
    meta: {"contentGroup":"team event"},
    props: true,
    name: "team-event-page___de-de"
  }, {
    path: "/en-us/c/:categorySlug?/",
    component: _24017c8a,
    pathToRegexpOptions: {"strict":true},
    name: "c-categorySlug___en-us"
  }, {
    path: "/en-us/city/:city?/",
    component: _90cbe692,
    pathToRegexpOptions: {"strict":true},
    name: "city-city___en-us"
  }, {
    path: "/en-us/e/:event?/",
    component: _26ce8556,
    pathToRegexpOptions: {"strict":true},
    name: "event___en-us",
    children: [{
      path: "",
      component: _50d89e4c,
      pathToRegexpOptions: {"strict":true},
      name: "e-event___en-us"
    }, {
      path: "BasicDetails/",
      component: _7ddbd71d,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-BasicDetails___en-us"
    }, {
      path: "EventBreadcrumbs/",
      component: _421ebd82,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-EventBreadcrumbs___en-us"
    }, {
      path: "EventIconList/",
      component: _65da9d58,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-EventIconList___en-us",
      children: [{
        path: "EventIconListTable/",
        component: _89284d78,
        pathToRegexpOptions: {"strict":true},
        name: "e-event-EventIconList-EventIconListTable___en-us"
      }]
    }, {
      path: "Gallery/",
      component: _0b2b2c0e,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-Gallery___en-us"
    }, {
      path: "LocationAndMap/",
      component: _f1ed447a,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-LocationAndMap___en-us"
    }, {
      path: "PrivateEventInfo/",
      component: _0daae7e4,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-PrivateEventInfo___en-us"
    }, {
      path: "ReviewShowcase/",
      component: _12981964,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-ReviewShowcase___en-us"
    }, {
      path: "composables/useEventBreadcrumbs/",
      component: _4ea4cdaa,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-composables-useEventBreadcrumbs___en-us"
    }, {
      path: "composables/useKftBuyBox/",
      component: _8d5aff08,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-composables-useKftBuyBox___en-us"
    }]
  }, {
    path: "/en-us/e/:event/",
    component: _26ce8556,
    meta: {"contentGroup":"event"},
    props: true,
    pathToRegexpOptions: {"strict":true},
    name: "event-page___en-us"
  }, {
    path: "/en-us/giftcard/:event/",
    component: _22a8a72e,
    meta: {"contentGroup":"giftcard"},
    props: true,
    pathToRegexpOptions: {"strict":true},
    name: "special-giftcards___en-us"
  }, {
    path: "/en-us/giftcard/:event/",
    component: _22a8a72e,
    meta: {"contentGroup":"giftcard"},
    props: true,
    pathToRegexpOptions: {"strict":true},
    name: "special-giftcards___en-us"
  }, {
    path: "/en-us/magazine/:slug/",
    component: _4ae15218,
    meta: {"contentGroup":"magazine"},
    props: true,
    name: "magazine-pages___en-us"
  }, {
    path: "/en-us/p/:permalink?/",
    component: _472b5888,
    pathToRegexpOptions: {"strict":true},
    name: "p-permalink___en-us"
  }, {
    path: "/en-us/p/:permalink/",
    component: _472b5888,
    meta: {"contentGroup":"partner"},
    props: true,
    name: "supplier-profile___en-us"
  }, {
    path: "/en-us/p/:permalink/",
    component: _472b5888,
    meta: {"contentGroup":"partner"},
    props: true,
    name: "supplier-profile___en-us"
  }, {
    path: "/en-us/preview/:previewPermalink?/",
    component: _599ca35a,
    pathToRegexpOptions: {"strict":true},
    name: "preview-previewPermalink___en-us"
  }, {
    path: "/en-us/review/:event?/",
    component: _60712eb1,
    pathToRegexpOptions: {"strict":true},
    name: "review-event___en-us"
  }, {
    path: "/en-us/t/:slug/",
    component: _bf44922c,
    meta: {"contentGroup":"tag"},
    props: true,
    name: "general-event-list-page___en-us"
  }, {
    path: "/en-us/t/:slug/",
    component: _bf44922c,
    meta: {"contentGroup":"tag"},
    props: true,
    name: "general-event-list-page___en-us"
  }, {
    path: "/en-us/teamevent/:city/",
    component: _afd5bc52,
    pathToRegexpOptions: {"strict":true},
    name: "teamevent-city___en-us"
  }, {
    path: "/en-us/teamevent/:city/",
    component: _afd5bc52,
    meta: {"contentGroup":"team event"},
    props: true,
    name: "team-event-page___en-us"
  }, {
    path: "/en-us/teamevent/:city/",
    component: _afd5bc52,
    meta: {"contentGroup":"team event"},
    props: true,
    name: "team-event-page___en-us"
  }, {
    path: "/de-de/:citySlug/",
    component: _90cbe692,
    meta: {"contentGroup":"city"},
    props: true,
    name: "city-page___de-de"
  }, {
    path: "/de-de/:citySlug/",
    component: _90cbe692,
    meta: {"contentGroup":"city"},
    props: true,
    name: "city-page___de-de"
  }, {
    path: "/en-us/:citySlug/",
    component: _90cbe692,
    meta: {"contentGroup":"city"},
    props: true,
    name: "city-page___en-us"
  }, {
    path: "/en-us/:citySlug/",
    component: _90cbe692,
    meta: {"contentGroup":"city"},
    props: true,
    name: "city-page___en-us"
  }, {
    path: "/de-de/:citySlug/:categorySlug/",
    component: _b1f895a0,
    meta: {"contentGroup":"city category"},
    props: true,
    name: "city-categories-page___de-de"
  }, {
    path: "/de-de/:citySlug/:categorySlug/",
    component: _b1f895a0,
    meta: {"contentGroup":"city category"},
    props: true,
    name: "city-categories-page___de-de"
  }, {
    path: "/en-us/:citySlug/:categorySlug/",
    component: _b1f895a0,
    meta: {"contentGroup":"city category"},
    props: true,
    name: "city-categories-page___en-us"
  }, {
    path: "/en-us/:citySlug/:categorySlug/",
    component: _b1f895a0,
    meta: {"contentGroup":"city category"},
    props: true,
    name: "city-categories-page___en-us"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
